/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { CarPlateStatusDtoFromJSON, CarPlateStatusDtoToJSON, } from './';
export function CarPlateStatusDtoListGenericServiceResultFromJSON(json) {
    return CarPlateStatusDtoListGenericServiceResultFromJSONTyped(json, false);
}
export function CarPlateStatusDtoListGenericServiceResultFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'result': !exists(json, 'result') ? undefined : (json['result'] === null ? null : json['result'].map(CarPlateStatusDtoFromJSON)),
        'errors': !exists(json, 'errors') ? undefined : json['errors'],
        'succeeded': !exists(json, 'succeeded') ? undefined : json['succeeded'],
    };
}
export function CarPlateStatusDtoListGenericServiceResultToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'result': value.result === undefined ? undefined : (value.result === null ? null : value.result.map(CarPlateStatusDtoToJSON)),
    };
}
